import React, { useEffect } from 'react';
import { useSelector, useDispatch } from '../../../store';
import { useBiLogger } from '../../Hoc/BiLogger/BiLoggerProvider';
// import { useFedopsLogger } from '../../../components/Hoc/Fedops/FedopsProvider';
import {
  selectTopProps,
  selectSessionId,
  selectGooglePayBtnColor,
  selectGooglePayCountryCode,
  selectGooglePayOptions,
  selectGooglePayDto,
} from '../../../selectors';
import { setGooglePayButtonVisibility } from '../../../actions/googlePay/common';
import { GooglePayView } from './view';
import { getPaymentRequestData } from './utils/getPaymentRequestData';
import { createOnClick } from './callbacks/createOnClick';
import { createOnShippingMethodSelected } from './callbacks/createOnShippingMethodSelected';
import { createOnShippingContactSelected } from './callbacks/createOnShippingContactSelected';
import { createOnPaymentAuthorized } from './callbacks/createOnPaymentAuthorized';
import { GooglePayButtonConfig } from './types';

export const GooglePayController: React.FC = () => {
  const dispatch = useDispatch();
  const biLogger = useBiLogger();
  // const fedopsLogger = useFedopsLogger();
  const googlePayPM = useSelector(selectGooglePayDto);
  const googlePayOptions = useSelector(selectGooglePayOptions);
  const countryCode = useSelector(selectGooglePayCountryCode);
  const color = useSelector(selectGooglePayBtnColor);
  const topProps = useSelector(selectTopProps);
  const sessionId = useSelector(selectSessionId);

  useEffect(() => {
    // TODO: DimaM add BI event
    // const { meta, requestShipping } = this.props.topProps;
    // this.props.biLogger.report(
    //   googlePayButtonRendered({
    //     pageType: getPageFingerprint(),
    //     cartId: meta.cartId,
    //     msid: meta.siteId,
    //     paymentmethod: BiPmGooglePay,
    //     paymentProvider: BiPpWp,
    //     requestShipping,
    //     visitorId: meta.visitorId,
    //   }),
    // );
    // props.getGooglePayOptions({ fedopsLogger: props.fedopsLogger });
  }, []);

  const paymentRequest = getPaymentRequestData({
    topProps,
    countryCode,
    sessionId,
    googlePayPM,
    googlePayOptions,
  });
  const { transactionInfo } = paymentRequest;
  const onClick = createOnClick({ topProps, biLogger });
  const onPaymentAuthorized = createOnPaymentAuthorized();
  const onShippingMethodSelected = createOnShippingMethodSelected({ topProps, transactionInfo, biLogger });
  const onShippingContactSelected = createOnShippingContactSelected({ topProps, transactionInfo, biLogger });
  const onPaymentDataChanged: GooglePayButtonConfig['onPaymentDataChanged'] = async (intermediatePaymentData) => {
    if (intermediatePaymentData.callbackTrigger === 'SHIPPING_OPTION') {
      return onShippingMethodSelected(intermediatePaymentData.shippingOptionData);
    }

    if (intermediatePaymentData.callbackTrigger === 'SHIPPING_ADDRESS') {
      return onShippingContactSelected(intermediatePaymentData.shippingAddress);
    }

    return {};
  };

  return (
    googlePayPM && (
      <GooglePayView
        locale={topProps.locale}
        height={topProps.buttonStyle?.height}
        color={color}
        paymentRequest={paymentRequest}
        onClick={onClick}
        onReadyToPayChange={(result) => {
          dispatch(setGooglePayButtonVisibility(result.isButtonVisible ? 'visible' : 'hidden'));
        }}
        /**
         * onLoadPaymentData - will be used in future
         * onError - will be used in future
         * onCancel - will be used in future
         */
        // onLoadPaymentData={(data) => {
        //   console.log('onLoadPaymentData', data);
        // }}
        // onError={(data) => {
        //   // ADD Sentry call
        //   console.log('onError', data);
        // }}
        // onCancel={(data) => {
        //   console.log('onCancel', data);
        // }}
        onPaymentAuthorized={onPaymentAuthorized}
        onPaymentDataChanged={onPaymentDataChanged}
      />
    )
  );
};
